import { ensureTownOnlyLocationSlugHasCountrySuffix } from './ensure-town-only-location-slug-has-country-suffix';
import { encodeLocationUrlPathSegment } from './encode-location-url-path-segment';
import { generateLocalizedLocationUrl, type LocationLocale } from './generate-localized-location-url';
import { toLocationSlug } from './to-location-slug';

function toLocationSlugFromMaybeEncoded(raw: string): string {
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    // keep raw when decoding fails
  }
  return toLocationSlug(decoded);
}

/**
 * Builds a percent-encoded location path segment for SRP URLs in a target locale.
 * Accepts display strings ("Helsinki, Finland"), slugs ("Helsinki_Finland"),
 * or URL segments (possibly percent-encoded).
 */
export function buildEncodedLocationSrpPathSegment(
  raw: string | null | undefined,
  targetLocale: LocationLocale,
): string {
  if (!raw) return '';
  const slug = toLocationSlugFromMaybeEncoded(raw);
  if (!slug) return '';
  const localizedSlug = generateLocalizedLocationUrl(slug, targetLocale);
  const withCountrySuffix = ensureTownOnlyLocationSlugHasCountrySuffix(
    toLocationSlug(localizedSlug),
    targetLocale,
  );
  return encodeLocationUrlPathSegment(withCountrySuffix);
}
